import { setActiveCalcValue } from "../../../calculator";
import { hideAndRemoveInArr } from "../../helpers";
import { toggleSingleSceneObject } from "../../togglers";
import { changePodstavkaPodNogi, changePodstavkaPodSistemniiBlok } from "../tables/down/down";

export const changeVarstakCategoryTumba = (value, side, isChecked = true) => {
    const { tempName } = servObj;
    const count = value.split("__")[2];
    const name = `verstak__${tempName}__tumba__ts_${count}__100x100__${side}`;

    const width = Number(servObj.tableSize.tableWidth.current);
    const depth = Number(servObj.tableSize.tableDepth.current);
    const pos_x_map = {
        1200: 0,
        1500: 0.15,
        1800: 0.3,
    };
    const posX = pos_x_map[width] * (side === "left" ? -1 : 1);
    const allArr = side === "right" ? servObj["allVerstakTumbaRight"] : servObj["allVerstakTumbaLeft"];
    const activeArr = side === "right" ? servObj["activeVerstakTumbaRight"] : servObj["activeVerstakTumbaLeft"];
    const activeNizhkiArr = side === "right" ? servObj["activeVerstakNozhkiRight"] : servObj["activeVerstakNozhkiLeft"];
    hideAndRemoveInArr(activeNizhkiArr);
    toggleSingleSceneObject({
        allObjects: allArr,
        activeArray: activeArr,
        name,
        isChecked: isChecked,
        filterActiveFn: () => {},
        position: {
            x: posX,
            y: 10,
            z: 0,
        },
    });
    let calc_name = "";
    const getTumbaBoxCount = (tumba) => (tumba ? Number(tumba.split("__")[3].split("_")[1]) : null);
    const leftTumbaBoxCount = getTumbaBoxCount(servObj.activeVerstakTumbaLeft[0]?.name);
    const rightTumbaBoxCount = getTumbaBoxCount(servObj.activeVerstakTumbaRight[0]?.name);

    const prefix = `verstak__${tempName}__${width}x${depth}`;

    if (leftTumbaBoxCount && !rightTumbaBoxCount) {
        calc_name = `${prefix}_t${leftTumbaBoxCount}`;
    } else if (!leftTumbaBoxCount && rightTumbaBoxCount) {
        calc_name = `${prefix}_t${rightTumbaBoxCount}`;
    } else if (leftTumbaBoxCount && rightTumbaBoxCount) {
        calc_name = `${prefix}_t${rightTumbaBoxCount}_t${leftTumbaBoxCount}`;
        if (!servObj.calc[calc_name]) {
            calc_name = `${prefix}_t${leftTumbaBoxCount}_t${rightTumbaBoxCount}`;
        }
    }

    setActiveCalcValue(calc_name, isChecked);

    //Обновим позицию подставки под ноги при смене тумбы
    // if (servObj.activePodstavkaPodNogi.length) {
    //     changePodstavkaPodNogi(true);
    // }
    // if (servObj.activePodstavkaPodSistemniiBlok.length) {
    //     const type = servObj.activePodstavkaPodSistemniiBlok[0]?.userData.type;
    //     changePodstavkaPodSistemniiBlok(type, true);
    // }
};
